/**
 * Generated by orval v6.20.0 🍺
 * Do not edit manually.
 * portrich-api
 * OpenAPI spec version: 0.0.0
 */

/**
 * * `EXPORT` - 輸出
* `IMPORT` - 輸入
* `BOTH` - 輸出入両方
 */
export type OperationDirectionEnum = typeof OperationDirectionEnum[keyof typeof OperationDirectionEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OperationDirectionEnum = {
  EXPORT: 'EXPORT',
  IMPORT: 'IMPORT',
  BOTH: 'BOTH',
} as const;
